import { Action } from '@ngrx/store';
import { UserData } from '../models/user-data.model';

export enum UserDataActionTypes {
  USERDATA_QUERY = '[UserData] Query',
  USERDATA_LOADED = '[UserData] Fetched',

  USERDATA_ADDED = '[UserData] Added',
  USERDATA_EDITED = '[UserData] Edited',
  USERDATA_DELETED = '[UserData] Deleted',
  USERDATA_SAVED = '[UserData] Saved',

  USERDATA_ERROR = '[UserData] Error'
}

export class UserDataQuery implements Action {
  readonly type = UserDataActionTypes.USERDATA_QUERY;
}

export class UserDataLoaded implements Action {
  readonly type = UserDataActionTypes.USERDATA_LOADED;

  constructor(public payload: { userdata: UserData[] }) {}
}

export class UserDataAdded implements Action {
  readonly type = UserDataActionTypes.USERDATA_ADDED;

  constructor(public payload: { userdata: UserData }) {}
}

export class UserDataEdited implements Action {
  readonly type = UserDataActionTypes.USERDATA_EDITED;

  constructor(public payload: { userdata: UserData }) {}
}

export class UserDataSaved implements Action {
  readonly type = UserDataActionTypes.USERDATA_SAVED;

  constructor(public payload: {userdata: UserData}) {}
}

export class UserDataDeleted implements Action {
  readonly type = UserDataActionTypes.USERDATA_DELETED;

  constructor(public payload: { userdata: UserData }) {}
}

export class UserDataError implements Action {
  readonly type = UserDataActionTypes.USERDATA_ERROR;

  constructor(public payload: { error: any }) {}
}

export type UserDataActions =
  | UserDataQuery
  | UserDataLoaded
  | UserDataAdded
  | UserDataEdited
  | UserDataSaved
  | UserDataDeleted
  | UserDataError;
